<template src="./MenuButton.html"> </template>
<script>
export default {
    name: 'MenuButton',
    props: {
        text: {
            required: true,
            type: String,
        },
    },
}
</script>

<style lang="scss" src="./MenuButton.scss"> </style>